import React from 'react';
import './Groups.less';
import { Modal } from 'antd';
import NewCustomButton from '../Common/NewCustomButton';
import { ButtonTypes } from '../Common/CustomButton';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import {
  CloseIcon,
  AddTaskIcon,
  NewCloseIcon,
  NewUpdateIcon,
  SaveChangesIcon,
  DeleteIcon,
  CallIcon,
  NewNotificationIcon,
  AttachmentLinkIcon,
  EditIcon,
} from '../Common/Icons';
import GroupAddEdit from './GroupModalComponents/GroupAddEdit';
import { GroupModalActions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { truncateStringWith3Dots } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';

const RemoveMemberConfirmModal = ({
  showRemoveMemberConfirmModal,
  closeRemoveMemberConfirmModal,
  record,
  removeMemberUuid,
  groupName,
  removeMemberName,
  setLatestGroupInfo,
}) => {
  const trans = useSelector(translator);
  const userGroupApi = useSelector((state) => state.apis.userGroupApi);

  const removeMemberHandler = () => {
    userGroupApi.removeUserFromGroup(
      record?.groupuuid,
      [{ useruuid: removeMemberUuid }],
      apiCallback({
        translator: trans,
        failCallback: errorCallback,
        errorCallback,
        successCallback,
      })
    );
  };

  const errorCallback = (error) => {
    setLatestGroupInfo();
    closeRemoveMemberConfirmModal();
    // message.error("Error removing member from group !");
    console.error('Error removing member from group:', error);
  };

  const successCallback = (data) => {
    setLatestGroupInfo();
    closeRemoveMemberConfirmModal();
  };

  return (
    <Modal
      open={showRemoveMemberConfirmModal}
      onOk={closeRemoveMemberConfirmModal}
      onCancel={closeRemoveMemberConfirmModal}
      footer={null}
      closable={false}
      centered
      className="group-modal-container"
      tabIndex={-1}
    >
      <div className="modal-container">
        {/* Header Section */}
        <div className="group-delete-modal-header-container">
          <div className="group-header-icon-title-new-container">
            <div className="group-modal-header-info">
              <div className="group-header-title-new">{trans('REMOVEMEMBER')}</div>
              <div className="group-header-sub-title">{`${trans('AREYOUSUREYOUWANTTOREMOVE')} “${truncateStringWith3Dots(removeMemberName, 15)}” ${trans('FROMETHE')} ${truncateStringWith3Dots(groupName, 15)} ${trans('GROUP?')}`}</div>
            </div>
          </div>
        </div>
        {/* Footer Buttons */}
        <div className="modal-footer">
          <NewCustomButton
            className="cancel-form-icon"
            label={trans('CANCEL')}
            icon={<NewCloseIcon style={{ fill: '#113E57' }} />}
            onClick={closeRemoveMemberConfirmModal}
          />
          <NewCustomButton
            disabled={false}
            type={ButtonTypes.primary}
            label={trans('YESREMOVEMEMBER')}
            icon={
              <NewUpdateIcon style={{ fill: '#003252' }} className={'create-group-icon-enabled'} />
            }
            onClick={() => {
              removeMemberHandler('useruuid');
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default RemoveMemberConfirmModal;
